import { useTranslations } from 'next-intl';
import React from 'react';

type Props = {
  metaHeader?: string;
  total: number;
};

function FoundAmountInternal({ total, metaHeader }: Props) {
  const t = useTranslations('productsSearchPage');

  return (
    <h1 className='md:mt-[28px] mt-[16px] md:mb-[22px] mb-[12px] md:text-[32px] text-[20px] text-primary font-semibold flex'>
      {metaHeader ? metaHeader : total > 0 ? t('found', { total }) : t('not_found')}
    </h1>
  );
}

export default React.memo(FoundAmountInternal);
